import React from 'react';

const Header = () => {
  return (
    <header className="text-white-600 body-font">
      <div className="container-fluid mr-0 flex flex-wrap p-5 flex-col md:flex-row items-center bg-[#006241] text-white">
        <a className="flex title-font font-medium items-center text-white mb-4 md:mb-0">
          <img 
            src="images/logo.jpeg" 
            className="w-10 h-10 text-white bg-grey-500 rounded-full" 
            alt="Prime Lawn Logo"
          />
          <span className="ml-3 text-xl font-600 font-bold">Prime Holiday Lights</span>
        </a>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-400 flex flex-wrap items-center text-base justify-center">
          <a href="tel:+17057950759" className="flex items-center gap-2 mr-5 text-white-900 font-semibold">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-5 h-5" viewBox="0 0 24 24">
              <path d="M6.62 10.79a15.093 15.093 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.07 21 3 13.93 3 5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.24.2 2.45.57 3.57a1 1 0 0 1-.24 1.02l-2.2 2.2z"/>
            </svg>
            Call Us: +1 (705) 795-0759
          </a>

          <a href="https://mail.google.com/mail/?view=cm&fs=1&to=primeholidaylights@gmail.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 mr-5 text-white-900 font-semibold">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-5 h-5" viewBox="0 0 24 24">
              <path d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v.01L12 13 2 4.01V4zm0 2.236v13.764A2 2 0 0 0 4 22h16a2 2 0 0 0 2-2V6.236l-9.197 7.424a1 1 0 0 1-1.606 0L2 6.236z"/>
            </svg>
            primeholidaylights@gmail.com
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;